import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { type DropdownEntry } from "~/common/types";

export const useTitleOptions = (): DropdownEntry<string>[] => {
  const { t } = useTranslation();
  return useMemo(() => {
    return window.SCHA.titleOptions.map((option) => ({
      value: option.code,
      label: t(option.name),
    }));
  }, []);
};
export const useSalutationOptions = (): DropdownEntry<string>[] => {
  const { t } = useTranslation();
  return useMemo(() => {
    return window.SCHA.salutationOptions.map((option) => ({
      value: option.code,
      label: t(option.name),
    }));
  }, []);
};

export const EMPTY_TITLE_CODE = "empty";
